export const compress_date =
    (timestamp_offset: number) =>
        (d: number) =>
            (d - timestamp_offset * 1000) / (100 * 1000);

export const uncompress_date =
    (timestamp_offset: number) =>
        (d: number) =>
            (d * 100 + timestamp_offset) * 1000;
